import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';

import customer from '../../customer';
const {getActivePermissions, hasMultipleSubscriptions, isMasterUser, isDemoUser} = customer.selectors;

import * as navBarActions from '../actions';
import {isNavbarCollapsed, isNavbarTransitioning, isErrorOpen} from '../selectors';

import NavIconBar from './NavIconBar';
import NavLinkBar from './NavLinkBar';
import SelectStoreModal from './SelectStoreModal';
import ChangePasswordModal from './ChangePasswordModal';
import ErrorModal from './ErrorModal';

function isDesktopClient() {
  const bootStrapXlSize = 1330;
  return Math.max(document.documentElement["clientWidth"], 
                  document.body["scrollWidth"], 
                  document.documentElement["scrollWidth"], 
                  document.body["offsetWidth"], 
                  document.documentElement["offsetWidth"]) >= bootStrapXlSize;
}

class NavBar extends React.Component {
  handleNavBarToggle = () => {
    if(!isDesktopClient() && !this.props.navTransitioning) {
      this.props.actions.toggleNavBar();
    }
  }

  handleNavBarClose = () => {
    if(!isDesktopClient() && !this.props.navCollapsed && !this.props.navTransitioning) {
      this.props.actions.closeNavBar();
    }
  }

  handleTransitionComplete = () => {
    if(!isDesktopClient()) {
      this.props.actions.transitionComplete();
    }
  }

  handleErrorModalClose = () => {
    this.props.actions.hideErrorModal();
  }

  render() {
    const {isMasterUser, isErrorOpen, navCollapsed, navLocation, multipleSubscriptions, userPermissions, isDemoUser} = this.props;
    return (
      <div>
        <div className="nav-side-menu">
          <h1 className="logo text-hide"><Link to="/">Petdata</Link></h1>
            <NavIconBar navLocation={navLocation} 
                        onClick={this.handleNavBarClose}
                        userPermissions={userPermissions}
            />
            <NavLinkBar navLocation={navLocation} 
                        navCollapsed={navCollapsed}
                        onClick={this.handleNavBarToggle}
                        onTransitionComplete={this.handleTransitionComplete}
                        userPermissions={userPermissions}
                        isMasterUser={isMasterUser}
                        isDemoUser = {isDemoUser}
            />
        </div>
        {multipleSubscriptions && <SelectStoreModal />}
        <ChangePasswordModal />
        <ErrorModal isOpen={isErrorOpen} onClose={this.handleErrorModalClose}/>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMasterUser: isMasterUser(state),
    isDemoUser: isDemoUser(state),
    isErrorOpen: isErrorOpen(state),
    multipleSubscriptions: hasMultipleSubscriptions(state),
    navLocation: `/${ownProps.location.split('/')[1]}`,
    navCollapsed: isNavbarCollapsed(state),
    navTransitioning: isNavbarTransitioning(state),
    userPermissions: getActivePermissions(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...navBarActions}, dispatch)
  };
}

NavBar.propTypes = {
  actions: PropTypes.object.isRequired,
  isMasterUser: PropTypes.bool.isRequired,
  isDemoUser: PropTypes.bool.isRequired,
  isErrorOpen: PropTypes.bool.isRequired,
  multipleSubscriptions: PropTypes.bool.isRequired,
  navLocation: PropTypes.string.isRequired,
  navCollapsed: PropTypes.bool.isRequired,
  navTransitioning: PropTypes.bool.isRequired,
  userPermissions: PropTypes.array.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/components/NavBar.js
 **/